
import * as React from 'react';
import Typography from '@mui/material/Typography';
import {  Grid2 } from '@mui/material';
import Container from '@mui/material/Container';


export default function About() {


  return (
    <React.Fragment>
      <Container maxWidth="xl" sx={{ my: 5 }}>
        <Grid2 container justifyContent={'space-between'}>
          <Grid2 size={{ xs: 12 }}>
            <Typography variant='h4'>Callgoose SQIBS</Typography>
            <Typography sx={{color:'text.secondary'}}>
            In today’s rapidly evolving business world, maintaining efficiency and responding swiftly to operational disruptions is critical for success. Real-time Incident Management, incident response, and automation are no longer just buzzwords but essential tools for organizations looking to optimize their daily operations. Enter Callgoose SQIBS, an advanced platform designed to streamline incident management and transform the way businesses operate through cutting-edge automation.
            </Typography>
           
          </Grid2>
        </Grid2>
      </Container>
    </React.Fragment>
  );
}
